import { useState } from 'react';
import PortfolioItemViewCardWithPageOverlay from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemViewCardWithPageOverlay';
import TaskBoard from '@/components/ChallengePortfolio/NormalView/TaskBoard';
import ChallengeContentWrapper from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContentWrapper';
import ChallengeHeader from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeHeader';
import ChallengeInfo from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeInfo';
import MobilePhaseSelect from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/MobilePhaseSelect';
import ChallengeContext from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContext';
import { type Challenge, type SetComplexImmerStateAction } from '@/lib/types';
import ChallengeColorBar from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeColorBar';
import ChallengePortfolioItemContextProvider from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengePortfolioItemContextProvider';
import PortfolioItemFields from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields';
import ModelType from '@/lib/constants/challengeModel/ModelType.enum';
import PortfolioItemThumbnailHeader from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemThumbnailHeader';
import ChallengeContentOuterWrapper from '@/components/ChallengePortfolio/NormalView/Challenge/ChallengeView/ChallengeContentOuterWrapper';
import { PortfolioItemCloseBlockingContextProvider } from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemCloseBlockingContext';

type CustomChallengeViewProps = {
  challenge: Challenge;
  setChallenge: SetComplexImmerStateAction<Challenge>;
  onClose: () => void;
};

// TODO don't unmount challengeviewcontent on taskboard open
const CustomChallengeView = ({
  challenge,
  setChallenge,
  onClose,
}: CustomChallengeViewProps) => {
  const [taskBoardOpen, setTaskBoardOpen] = useState(false);

  return (
    <PortfolioItemCloseBlockingContextProvider>
      <PortfolioItemViewCardWithPageOverlay
        variant="challenge"
        taskBoardOpen={taskBoardOpen}
        onClose={onClose}
        onCloseTaskBoard={() => setTaskBoardOpen(false)}
      >
        <ChallengeContext.Provider value={[challenge, setChallenge]}>
          {taskBoardOpen && <TaskBoard />}
          <ChallengePortfolioItemContextProvider>
            <ChallengeContentOuterWrapper hidden={taskBoardOpen}>
              <PortfolioItemThumbnailHeader />
              <ChallengeColorBar challengeColor={challenge.color} />
              <ChallengeContentWrapper>
                <ChallengeHeader onTasksOpen={() => setTaskBoardOpen(true)} />
                <ChallengeInfo />
                <MobilePhaseSelect />
                <PortfolioItemFields modelType={ModelType.CHALLENGE} />
              </ChallengeContentWrapper>
            </ChallengeContentOuterWrapper>
          </ChallengePortfolioItemContextProvider>
        </ChallengeContext.Provider>
      </PortfolioItemViewCardWithPageOverlay>
    </PortfolioItemCloseBlockingContextProvider>
  );
};

export default CustomChallengeView;
